import * as React from "react";
const SvgGridRemove20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17 2H1v14h9v-6h5v2h2V2Zm-9 8v4H3v-4h5Zm0-2H3V4h5v4Zm2 0V4h5v4h-5Zm2 8h8v-2h-8v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgGridRemove20Px;
